import Vue from 'vue';
import Vuex from 'vuex';

import auth from '@/auth';
import { firebase, db } from './db';

Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    auth: {
      isInitialized: false,
      isSignedIn: false,
      email: null,
      uid: null,
      isAnonymous: true,
      hasAccess: false,
    },
    offers: {
      filter: {
        sort: {
          by: 'name',
        },
      },
      inProgress: false,
      isFailed: false,
      data: [],
    },
  },
  mutations: {
    'OFFERS/FETCH/START': (state) => {
      state.offers.inProgress = true;
    },

    'OFFERS/FETCH/SUCCESS': (state, data) => {
      state.offers.data = data;
      state.offers.inProgress = false;
      state.offers.isFailed = false;
    },

    'OFFERS/FETCH/FAIL': (state) => {
      state.offers.data = [];
      state.offers.inProgress = false;
      state.offers.isFailed = true;
    },

    'OFFERS/FILTERS/SORTING/SET': (state, payload) => {
      state.offers.filter.sort.by = payload.by;
    },

    'AUTH/SIGNED_IN': (state, data) => {
      state.auth = {
        ...state.auth,
        isInitialized: true,
        isSignedIn: true,
        email: data.email,
        uid: data.uid,
        isAnonymous: data.isAnonymous,
        hasAccess: data.claims ? data.claims.hasAccess : false,
      };
    },

    'AUTH/LOGGED_OUT': (state) => {
      state.auth = {
        ...state.auth,
        isInitialized: true,
        isSignedIn: false,
        email: null,
        uid: null,
        isAnonymous: true,
        hasAccess: false,
      };
    },
  },
  actions: {
    signedIn({ commit }, data) {
      commit('AUTH/SIGNED_IN', data);
    },

    signInByPassword(store, data) {
      return auth.signInByPassword(data.email, data.password);
    },

    signInByFacebook() {
      return auth.signInByFacebook();
    },

    logout({ commit }) {
      return new Promise((resolve, reject) => {
        firebase.auth().signOut().then(() => {
          commit('AUTH/LOGGED_OUT');
          resolve();
        }).catch((error) => {
          reject(error);
        });
      });
    },

    fetchOffers({ commit }) {
      const offersCol = db.collection('offers');
      const offers = [];
      commit('OFFERS/FETCH/START');

      offersCol
        .get()
        .then((qs) => {
          qs.forEach((offer) => {
            offersCol
              .doc(offer.id)
              .collection('prices')
              .orderBy('date', 'desc')
              .get()
              .then((prices) => {
                const offerPrices = prices.docs.map(price => price.data());

                offers.push({
                  id: offer.id,
                  ...offer.data(),
                  lastPrice: offerPrices.length > 0 ? offerPrices[0].price : null,
                  prices: offerPrices,
                });
              });
          });

          commit('OFFERS/FETCH/SUCCESS', offers);
        }).catch((error) => {
          commit('OFFERS/FETCH/FAIL', error);
        });
    },

    setSorting({ commit }, payload) {
      commit('OFFERS/FILTERS/SORTING/SET', payload);
    },
  },
});
